<div class="fill-parent">


  <div class="display-flex align-items-centered margin-t-l">

    <div class="search-container display-flex align-items-centered margin-r-s margin-l-s w-50">
      <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
      <input type="search" class="search-without-border" placeholder="Search By Name" />
    </div>
    <div class="margin-r-s margin-l-s">
      <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Reset Filters</span>
    </div>
  </div>
  <div class="display-flex align-items-centered margin-t-xl flex-wrap">
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter">
        <mat-label class="filter-label">Country</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter" matTooltip="Please Select Country to Enable this Filter" matTooltipClass="gray-tootltip" matTooltipPosition="above"
                      aria-label="Button that displays a tooltip when focused or hovered over">
        <mat-label class="filter-label">Region</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true" [disabled]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter" matTooltip="Please Select Region to Enable this Filter" matTooltipClass="gray-tootltip" matTooltipPosition="above"
                      aria-label="Button that displays a tooltip when focused or hovered over">
        <mat-label class="filter-label">Sub County</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true" [disabled]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter" matTooltip="Please Select Sub County to Enable this Filter"matTooltipClass="gray-tootltip"  matTooltipPosition="above"
                      aria-label="Button that displays a tooltip when focused or hovered over">
        <mat-label class="filter-label">Wards</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true" [disabled]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>


    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter">
        <mat-label class="filter-label">Site Type</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter">
        <mat-label class="filter-label">School Type</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter">
        <mat-label class="filter-label">Reading Club</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true">

          <div class="search-container display-flex align-items-centered margin-t-l margin-b-l">
            <span style="width:40px" class="border-right display-flex align-items-centered justify-center"><mat-icon class="icon-color">search</mat-icon></span>
            <input type="search" class="search-without-border" placeholder="Search By Country Name" />
          </div>
          <div class="divider"></div>

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="margin-r-s margin-l-s">
      <mat-form-field appearance="fill" class="filter">
        <mat-label class="filter-label">Public / Private</mat-label>
        <mat-select matNativeControl panelClass="myFilterClass" [disableOptionCentering]="true">

          <mat-option value="Country 1"> <mat-checkbox class="example-margin" color='primary'>Country 1</mat-checkbox></mat-option>
          <mat-option value="Country 2"> <mat-checkbox class="example-margin" color='primary'>Country 2</mat-checkbox></mat-option>
          <mat-option value="Country 3"> <mat-checkbox class="example-margin" color='primary'>Country 3</mat-checkbox></mat-option>
          <div class="divider"></div>
          <span class=" margin-t-l margin-b-l display-flex justify-end gray-color txt-decortion-underline curser-pointer">Clear</span>
        </mat-select>
      </mat-form-field>
    </div>


  </div>


  <div class="map-section display-flex align-items-centered margin-t-l">
    <div class="flex-grow-1"></div>

      <div class="map-guidline box-shadow-gray padding-l" [class.close-guidline]="closeguidline">
    
        <div class="margin-t-l" [class.remove-me]="closeguidline">
          <div class="bold margin-b-s">Site type</div>
          <div class="margin-b-s"> <img src="assets/images/green-pin.svg" /> <span>School</span></div>
          <div class="margin-b-s"> <img src="assets/images/orange-pin.svg" /> <span>Reading Camp /Office</span></div>
          <div class="margin-b-s"> <img src="assets/images/blue-pin.svg" /> <span>Library</span></div>
          <div class="divider margin-t-l margin-b-l"></div>
          <div class="bold  margin-b-s">School Type</div>
          <div class="margin-b-s"> <img src="assets/images/white-circle.svg" /> <span>Mainstream</span></div>
          <div class="margin-b-s"> <img src="assets/images/purple-circle.svg" /> <span>Special Needs</span></div>
          <!-- <div class="margin-b-s"> <img src="assets/images/white-circle.svg" /> <span>Attached Unit - Integrated</span></div> -->
          <div class="margin-b-s"> <img src="assets/images/orange-circle.svg" /> <span>Inclusive School</span></div>
          <!-- <div class="margin-b-s"> <img src="assets/images/yellow-circle.svg" /> <span>UNHCR</span></div> -->
        </div>
      </div>

  </div>
</div>
